import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export const PluginWidgetStaticSchema = BaseWidgetSchema(WidgetType.Plugin).extend({
  pluginId: z.string()
});

export type PluginWidgetStaticSchemaType = z.infer<typeof PluginWidgetStaticSchema>;
